import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import { empty } from 'ramda';
import { FormattedMessage } from 'react-intl';
import { Container, BackIcon, CloseIcon, StepDisplay, Title, Content, Header, StepInfo } from './overlay.styles';
import { Icon, ICON_ARROW_LEFT, ICON_CROSS } from '../icon';
import messages from './overlay.messages';
import { renderWhenNotNil } from '../../utils/rendering';

export class Overlay extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    closeUrl: PropTypes.string,
    step: PropTypes.number,
    theme: PropTypes.object,
    title: PropTypes.any,
    onBackClicked: PropTypes.func,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    onBackClicked: empty,
  };

  handleBackClicked = this.props.onBackClicked;

  handleOnClose = e => {
    const { onClose } = this.props;

    if (onClose) {
      e.preventDefault();
      this.props.onClose();
    }
  };

  renderStepDisplay = step => (
    <StepDisplay>
      <BackIcon stroked name={ICON_ARROW_LEFT} onClick={this.handleBackClicked} inactive={step === 0} />
      <StepInfo>
        <FormattedMessage {...messages.stepDisplay} values={{ step: step + 1 }} />
      </StepInfo>
    </StepDisplay>
  );

  renderTitle = title => <Title>{title}</Title>;

  renderCloseIcon = () => (
    <CloseIcon to={this.props.closeUrl || '/'} onClick={this.handleOnClose}>
      <Icon stroked name={ICON_CROSS} size={32} />
    </CloseIcon>
  );

  render() {
    const { title, step, closeUrl, onClose } = this.props;
    return (
      <Container>
        {ReactDOM.createPortal(
          <Header>
            {renderWhenNotNil(this.renderStepDisplay)(step)}
            {renderWhenNotNil(this.renderTitle)(title)}
            {renderWhenNotNil(this.renderCloseIcon)(closeUrl || onClose)}
          </Header>,
          document.body
        )}
        <Content>{this.props.children}</Content>
      </Container>
    );
  }
}
